"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.SQLEditorTestUtils = void 0;
const tslib_1 = require("tslib");
const testData = tslib_1.__importStar(require("../mocks/testData"));
const statementPosition_1 = require("./statementPosition");
exports.SQLEditorTestUtils = {
    testData,
    testStatementPosition: statementPosition_1.testStatementPosition,
};
//# sourceMappingURL=index.js.map